import { LearnMoreLink, SectionDemoLink } from '../CTAButtons/CTAButtons';
import { routes } from '../../config/links';
import { features } from '../../data/features';
import styles from './Features.module.css';

function Features() {
  return (
    <section id="features" className={`section ${styles.section}`} aria-labelledby="features-heading">
      <div className="container">
        <span className="sectionLabel">Features</span>
        <h2 id="features-heading" className="sectionTitle">
          Everything your venue team needs on game day
        </h2>
        <p className="sectionSubtitle">
          A stadium-native platform designed for operators — with a fan experience that keeps guests in their seats.
        </p>

        <div className={styles.grid}>
          {features.map((feature) => (
            <article key={feature.title} className={styles.card}>
              <span className={styles.icon} aria-hidden="true">{feature.icon}</span>
              <h3 className={styles.title}>{feature.title}</h3>
              <p className={styles.description}>{feature.description}</p>
            </article>
          ))}
        </div>
        <div className={styles.links}>
          <LearnMoreLink to={routes.features} label="Explore all features →" />
          <SectionDemoLink />
        </div>
      </div>
    </section>
  );
}

export default Features;
